export enum UserSessionEntityType {
  SUPER_ADMINISTRATION = "SUPER_ADMINISTRATION",
  BUSINESS_UNIT = "BUSINESS_UNIT",
  ADMINISTRATION = "ADMINISTRATION",
  OPERATOR = "OPERATOR",
}
